"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LicenseType = exports.DiscountCodeLogEventType = exports.ReconciliationAccountingType = exports.LedgerStatus = exports.LedgerType = exports.ReconciliationType = exports.ReconciliationProcessingStatus = exports.OrderOrigin = exports.PaymentEventType = exports.PaymentProvider = exports.PaymentStatus = void 0;
/* eslint-disable no-shadow */
var PaymentStatus;
(function (PaymentStatus) {
    PaymentStatus["checkout_incomplete"] = "checkout_incomplete";
    PaymentStatus["checkout_complete"] = "checkout_complete";
    PaymentStatus["checkout_declined"] = "checkout_declined";
    PaymentStatus["checkout_failed"] = "checkout_failed";
    PaymentStatus["checkout_voided"] = "checkout_voided";
    PaymentStatus["checkout_refunded"] = "checkout_refunded";
    PaymentStatus["checkout_authorized"] = "checkout_authorized";
    PaymentStatus["checkout_started"] = "checkout_started";
})(PaymentStatus = exports.PaymentStatus || (exports.PaymentStatus = {}));
var PaymentProvider;
(function (PaymentProvider) {
    PaymentProvider["EMPTY"] = "EMPTY";
    PaymentProvider["DINTERO"] = "DINTERO";
    PaymentProvider["LEID"] = "LEID";
    PaymentProvider["OPERATOR"] = "OPERATOR";
    PaymentProvider["SYSTIMA"] = "SYSTIMA";
    PaymentProvider["POWEROFFICE"] = "POWEROFFICE";
    PaymentProvider["MANUAL_REFUND"] = "MANUAL_REFUND";
    PaymentProvider["OPERATOR_INVOICE"] = "OPERATOR_INVOICE";
    PaymentProvider["HYGGLO"] = "HYGGLO";
})(PaymentProvider = exports.PaymentProvider || (exports.PaymentProvider = {}));
var PaymentEventType;
(function (PaymentEventType) {
    PaymentEventType["CREATE"] = "CREATE";
    PaymentEventType["UPDATE"] = "UPDATE";
})(PaymentEventType = exports.PaymentEventType || (exports.PaymentEventType = {}));
var OrderOrigin;
(function (OrderOrigin) {
    OrderOrigin["LEID"] = "LEID";
    OrderOrigin["MANAGER"] = "MANAGER";
})(OrderOrigin = exports.OrderOrigin || (exports.OrderOrigin = {}));
var ReconciliationProcessingStatus;
(function (ReconciliationProcessingStatus) {
    ReconciliationProcessingStatus["PENDING"] = "PENDING";
    ReconciliationProcessingStatus["COMPLETED"] = "COMPLETED";
})(ReconciliationProcessingStatus = exports.ReconciliationProcessingStatus || (exports.ReconciliationProcessingStatus = {}));
var ReconciliationType;
(function (ReconciliationType) {
    ReconciliationType["GENERAL"] = "GENERAL";
    ReconciliationType["DISCOUNT"] = "DISCOUNT";
    ReconciliationType["ADJUSTMENT"] = "ADJUSTMENT";
})(ReconciliationType = exports.ReconciliationType || (exports.ReconciliationType = {}));
var LedgerType;
(function (LedgerType) {
    LedgerType["PRIMARY"] = "PRIMARY";
    LedgerType["SECONDARY"] = "SECONDARY";
})(LedgerType = exports.LedgerType || (exports.LedgerType = {}));
var LedgerStatus;
(function (LedgerStatus) {
    LedgerStatus["SENT"] = "SENT";
    LedgerStatus["REVERTED"] = "REVERTED";
})(LedgerStatus = exports.LedgerStatus || (exports.LedgerStatus = {}));
var ReconciliationAccountingType;
(function (ReconciliationAccountingType) {
    ReconciliationAccountingType["LEID"] = "LEID";
    ReconciliationAccountingType["LEID_RENTAL"] = "LEID_RENTAL";
    ReconciliationAccountingType["FRANCHISEE"] = "FRANCHISEE";
    ReconciliationAccountingType["SAAS"] = "SAAS";
    ReconciliationAccountingType["REQUEST"] = "REQUEST";
})(ReconciliationAccountingType = exports.ReconciliationAccountingType || (exports.ReconciliationAccountingType = {}));
var DiscountCodeLogEventType;
(function (DiscountCodeLogEventType) {
    DiscountCodeLogEventType["CREATED"] = "CREATED";
    DiscountCodeLogEventType["USED"] = "USED";
    DiscountCodeLogEventType["UPDATED"] = "UPDATED";
    DiscountCodeLogEventType["DELETED"] = "DELETED";
    DiscountCodeLogEventType["ERROR"] = "ERROR";
})(DiscountCodeLogEventType = exports.DiscountCodeLogEventType || (exports.DiscountCodeLogEventType = {}));
var LicenseType;
(function (LicenseType) {
    LicenseType["PLATFORM_LICENSE"] = "PLATFORM_LICENSE";
    LicenseType["PARTNER_PORTAL_LICENSE"] = "PARTNER_PORTAL_LICENSE";
    LicenseType["LOCATION_LICENSE"] = "LOCATION_LICENSE";
    LicenseType["SELFSERVICE_LICENSE"] = "SELFSERVICE_LICENSE";
    LicenseType["PADLOCK_LICENSE"] = "PADLOCK_LICENSE";
    LicenseType["GPS_LICENSE"] = "GPS_LICENSE";
    LicenseType["FINANCING"] = "FINANCING";
})(LicenseType = exports.LicenseType || (exports.LicenseType = {}));
